import CityPageTemplate from "../city-template/CityPageTemplate";
import { morenoValleyConfig } from "./data";

export default function MorenoValleyPage() {
  return <CityPageTemplate config={morenoValleyConfig} />;
}